import { render, staticRenderFns } from "./TheCotizacionForm.vue?vue&type=template&id=04af957e&scoped=true"
import script from "./TheCotizacionForm.vue?vue&type=script&lang=js"
export * from "./TheCotizacionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af957e",
  null
  
)

export default component.exports